var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showCreateModal
        ? _c("CreateAcquirerAffiliationModal", {
            attrs: {
              acquirer: _vm.consentData.acquirer,
              loading: _vm.redirectAffiliationLoading,
            },
            on: {
              confirm: _vm.redirectAffiliation,
              close: () => (_vm.showCreateModal = false),
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex flex-col gap-2" },
        [
          _vm.showConfirmAlert
            ? _c("ConfirmAcquirerAffiliationAlert")
            : _vm._e(),
          _vm.showUpdateAlert ? _c("UpdateAcquirerAffiliationAlert") : _vm._e(),
          _vm.showErrorAlert ? _c("ErrorAcquirerAffiliationAlert") : _vm._e(),
          _vm.showSuccessAlert
            ? _c("SuccessAcquirerAffiliationAlert", {
                attrs: { acquirer: _vm.consentData.acquirer },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("ConfigBox", {
        ref: "acquirerConfigBox",
        attrs: {
          loading: _vm.showLoading,
          as: _vm.asDivInsteadOfFieldSet,
          callback: _vm.saveAcquirerAffiliation,
          title: _vm.$t("acquirers"),
          hideEditButton: !_vm.canEdit,
          hiddenAlert: "",
        },
        on: { cancelEdit: _vm.handleCancelEdit },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-4" },
                  [
                    _vm.showCreate
                      ? _vm._l(
                          _vm.availableAcquirerAffiliations,
                          function (affiliation, index) {
                            return _c("CreateAffiliationItem", {
                              key: affiliation.acquirer + index,
                              attrs: {
                                acquirer: affiliation,
                                loading: _vm.redirectAffiliationLoading,
                                canCreate: _vm.canCreate,
                              },
                              on: { handleCreate: _vm.handleCreateAffiliation },
                            })
                          }
                        )
                      : _vm._e(),
                    _vm.consentData.acquirer?.affiliation_code
                      ? _c("AffiliationItem", {
                          attrs: { acquirer: _vm.consentData.acquirer },
                        })
                      : _vm._e(),
                    _vm._l(
                      _vm.acquirerAffiliations,
                      function (affiliation, index) {
                        return _c("AffiliationItem", {
                          key: affiliation.acquirer + index,
                          attrs: { acquirer: affiliation },
                          on: { handleChange: _vm.setStatusByAcquierer },
                        })
                      }
                    ),
                    _vm.hasAffiliationsCreated
                      ? _c(
                          "jade-button",
                          {
                            staticClass: "max-w-56 self-end mt-2",
                            attrs: {
                              variant: "neutral-subtle",
                              size: "medium",
                              icon: "plus",
                            },
                            on: { click: _vm.handleCreateAffiliation },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("affiliation-add")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }